import {
  Component,
  OnInit,
  ComponentRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  IModalDialog,
  IModalDialogOptions,
  IModalDialogButton,
  IModalDialogSettings,
} from 'ngx-modal-dialog';
import { UtilsService } from '../../../services/utils.service';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { AlgConsensoService } from '../../../services/alg-consenso.service';
import { Status } from '../../../models/fisso';
import { Attivazione } from '../../../models/attivazione';
import { AlgAttivazioniService } from '../../../services/alg-attivazioni.service';
@Component({
  selector: 'alg-otp-modal',
  templateUrl: './alg-otp-modal.component.html',
  styleUrls: ['./alg-otp-modal.component.scss'],
})
export class AlgOtpModalComponent implements OnInit, IModalDialog {
  public code_1: number = null;
  public code_2: number = null;
  public code_3: number = null;
  public code_4: number = null;
  public description: string;
  public phone_number: number = null;
  public old_phone_number: number = null;
  public modified: boolean = false;
  public new_sms_sent: boolean = false;
  public consensoType: boolean | string;
  public linear: boolean;
  private isConsentsOk: any;
  private consents: any;
  private unipol: boolean = false;
  public code_status_class = 'input-field';
  public error_message_label = null;
  public htmlPage: string;
  public textPage: string;
  public attivazione: Attivazione;

  actionButtons: IModalDialogButton[];

  constructor(
    private utils: UtilsService,
    private api: ApiService,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
    private attivazioneService: AlgAttivazioniService
  ) {}

  ngOnInit() {
    this.attivazioneService.attivazione$.subscribe((attivazione) => {
      if (!attivazione) {
        return;
      }
      this.attivazione = attivazione;
    });
  }

  fake_p_reject(data) {
    return new Promise((resolve, reject) => reject(data));
  }
  fake_p_resolve() {
    return new Promise((resolve, reject) => resolve(null));
  }

  sendMeOtpCode() {
    if (
      !this.phone_number ||
      this.phone_number.toString().length > 10 ||
      this.phone_number.toString().length < 9
    ) {
      return;
    }
    const id =
      this.consensoType === 'request' ||
      this.consensoType === 'agile_request' ||
      this.consensoType === 'fisso_request' ||
      this.consensoType === 'change_plan_request' ||
      this.consensoType === 'autoricarica' ||
      this.consensoType === 'billing_frequency' ||
      this.consensoType === 'attivazione' ||
      this.consensoType === 'docs_reception_request' ||
      this.consensoType === 'supply_invoice_reception_request' ||
      this.consensoType === 'payment_method_request'
        ? this.consents.requestId ||
          this.consents.contractId ||
          this.consents.ContractId
        : this.consents.id;
    return this.api
      .sendMeOtpCode(this.phone_number, id, this.consensoType)
      .subscribe((response) => {
        if (
          response.status &&
          response.statusText &&
          response.status === 429 &&
          response.statusText === 'Too Many Requests'
        ) {
          this.new_sms_sent = false;
          this.error_message_label =
            'Potrai richiedere un nuovo codice tra: 1 minuto';
          return;
        }
        return;
      });
  }

  async checkOtpCode() {
    this.new_sms_sent = false;
    this.code_status_class = 'input-field';
    this.error_message_label = null;
    if (!this.code_1 || !this.code_4 || !this.code_3 || !this.code_2) {
      return this.fake_p_reject('CODEREUIRED');
    } else if (
      isNaN(this.code_1) ||
      isNaN(this.code_2) ||
      isNaN(this.code_3) ||
      isNaN(this.code_4)
    ) {
      return this.fake_p_reject('JUSTNUMBER');
    }
    const code =
      `${this.code_1}${this.code_2}${this.code_3}${this.code_4}`.toString();
    const id =
      this.consensoType === 'request' ||
      this.consensoType === 'agile_request' ||
      this.consensoType === 'fisso_request' ||
      this.consensoType === 'change_plan_request' ||
      this.consensoType === 'autoricarica' ||
      this.consensoType === 'billing_frequency' ||
      this.consensoType === 'attivazione' ||
      this.consensoType === 'docs_reception_request' ||
      this.consensoType === 'supply_invoice_reception_request' ||
      this.consensoType === 'payment_method_request'
        ? this.consents.requestId ||
          this.consents.contractId ||
          this.consents.ContractId
        : this.consents.id;
    return this.api.checkOtpCode(code, id, this.consensoType).toPromise();
  }

  dialogInit(
    reference: ComponentRef<IModalDialog>,
    options: Partial<IModalDialogOptions<any>>
  ) {
    this.description = options.data.description;
    this.isConsentsOk = options.data.isConsentsOk;
    this.consents = options.data.consents;
    this.phone_number = options.data.phone;
    this.old_phone_number = options.data.phone;
    this.unipol = options.data.unipol ? true : false;
    this.consensoType = options.data.consensoType;
    this.htmlPage = options.data.htmlPage;
    this.textPage = options.data.textPage;
    options.settings.modalDialogClass = 'modal-dialog-otp';
    options.settings.modalClass = 'modal otp-modal fade ngx-modal';
    options.settings.contentClass = 'modal-content-otp';
    options.settings.bodyClass = 'bodyClass';
    options.settings.headerTitleClass =
      'modal-title modal-title-under line-otp textCenter modal-title-otp';
    this.sendMeOtpCode();
    this.actionButtons = [
      {
        text: '',
        buttonClass: 'alg-btn-close',
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
      {
        text: 'Conferma codice',
        buttonClass: 'dialog-action-button otp-alg-btn',
        onAction: async () => {
          const code =
            `${this.code_1}${this.code_2}${this.code_3}${this.code_4}`.toString();
          if (code.length > 4) {
            this.error_message_label = 'Il codice non è completo';
            this.code_status_class = 'input-error';
            return this.fake_p_reject(null);
          }
          return await this.checkOtpCode()
            .then((response) => {
              if (this.isConsentsOk) {
                const tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                const localISOTime = new Date(Date.now() - tzoffset)
                  .toISOString()
                  .slice(0, -1);

                if (this.unipol && this.consensoType !== 'request') {
                  const newConsentsObject = {
                    ...this.consents,
                    otpDate: new Date().toISOString(),
                    otpPhone: this.phone_number,
                    otpVerified: true,
                    unipol: this.unipol,
                  };
                  this.consensoService.saveConsentsUnipol(
                    this.consents.id,
                    newConsentsObject,
                    false
                  );
                }
                if (
                  !this.unipol &&
                  this.consensoType !== 'request' &&
                  this.consensoType !== 'agile_request' &&
                  this.consensoType !== 'fisso_request' &&
                  this.consensoType !== 'change_plan_request' &&
                  this.consensoType !== 'autoricarica' &&
                  this.consensoType !== 'attivazione' &&
                  this.consensoType !== 'billing_frequency' &&
                  this.consensoType !== 'docs_reception_request' &&
                  this.consensoType !== 'supply_invoice_reception_request' &&
                  this.consensoType !== 'payment_method_request'
                ) {
                  const newConsentsObject = {
                    ...this.consents,
                    otpDate: new Date().toISOString(),
                    otpPhone: this.phone_number,
                    otpVerified: true,
                    unipol: this.unipol,
                  };

                  this.consensoService.saveConsents(
                    this.consents.id,
                    newConsentsObject,
                    false
                  );
                }
                if (this.consensoType === 'request') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: new Date().toISOString(),
                    Alg_OTPPhone__c: this.phone_number,
                  };

                  this.consensoService.saveLinearRequest(newConsentsObject);
                }
                if (this.consensoType === 'agile_request') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: new Date().toISOString(),
                    Alg_OTPPhone__c: this.phone_number,
                    htmlPage: this.htmlPage,
                    textPage: this.textPage,
                  };

                  this.consensoService.saveAgileRequest(newConsentsObject);
                  this.consensoService.isOtpAgileRequest$.next(true);
                }
                if (this.consensoType === 'fisso_request') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: new Date().toISOString(),
                    Alg_OTPPhone__c: this.phone_number,
                    Stato: Status.ok,
                    htmlPage: this.htmlPage,
                    textPage: this.textPage,
                  };
                  this.consensoService.saveFissoRequest(newConsentsObject);
                  this.consensoService.isSecontStepFissoRequest$.next(true);
                }
                if (this.consensoType === 'change_plan_request') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: localISOTime,
                    Alg_OTPPhone__c: this.phone_number,
                  };
                  this.consensoService.saveChangePlanRequestAndSendEmail(
                    newConsentsObject
                  );
                  this.consensoService.isSecontStepFissoRequest$.next(true);
                }
                if (this.consensoType === 'billing_frequency') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: localISOTime,
                    Alg_OTPPhone__c: this.phone_number,
                  };
                  this.consensoService.saveBillingFrequencyRequestAndSendEmail(
                    newConsentsObject
                  );
                  this.consensoService.isOtpBillingFrequencyRequest$.next(true);
                }
                if (this.consensoType === 'docs_reception_request') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: localISOTime,
                    Alg_OTPPhone__c: this.phone_number,
                  };
                  this.consensoService.saveDocsReceptionRequestAndSendEmail(
                    newConsentsObject
                  );
                  this.consensoService.isOtpDocsReceptionRequest$.next(true);
                }
                if (this.consensoType === 'supply_invoice_reception_request') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: localISOTime,
                    Alg_OTPPhone__c: this.phone_number,
                  };
                  this.consensoService.saveSupplyInvoiceReceptionRequestAndSendEmail(
                    newConsentsObject
                  );
                  this.consensoService.isOtpSupplyInvoiceReceptionRequest$.next(
                    true
                  );
                }
                if (this.consensoType === 'payment_method_request') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: localISOTime,
                    Alg_OTPPhone__c: this.phone_number,
                  };
                  this.consensoService.savePaymentMethodRequestAndSendEmail(
                    newConsentsObject
                  );
                  this.consensoService.isOtpPaymentMethodRequest$.next(true);
                }
                if (this.consensoType === 'autoricarica') {
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: localISOTime,
                    Alg_OTPPhone__c: this.phone_number,
                  };
                  this.consensoService.saveAutoricaricaRequestAndSendEmail(
                    newConsentsObject
                  );
                  this.consensoService.otpTimeCheck$.next(localISOTime);
                  this.consensoService.isSecondStepAutoricarica$.next(true);
                }

                if (this.consensoType === 'attivazione') {
                  const generateUTCDate = new Date(localISOTime);
                  generateUTCDate.setUTCHours(generateUTCDate.getUTCHours());
                  const currentDate = generateUTCDate.toISOString();
                  const newConsentsObject = {
                    ...this.consents,
                    Alg_OTPCheck__c: true,
                    Alg_OTPCheckDate__c: currentDate,
                    Alg_OTPPhone__c: this.phone_number,
                    complete: true,
                  };
                  this.attivazioneService.otpTimeCheck$.next(localISOTime);
                  this.attivazioneService.saveConsents(
                    this.attivazione.opportunityId,
                    newConsentsObject,
                    true
                  );
                  const attivazione = this.attivazione;
                  this.attivazioneService.nextStep(
                    { ...attivazione, ...newConsentsObject },
                    'step4'
                  );
                }
              }
              this.utils.abilityOverflow();
              return this.fake_p_resolve();
            })
            .catch((err) => {
              console.log('ERRORE', err);
              if (err === 'JUSTNUMBER') {
                this.error_message_label =
                  'Il codice è composto solo da numeri';
                this.code_status_class = 'input-error';
              } else if (err === 'CODEREUIRED') {
                this.error_message_label = 'Il codice è richiesto';
                this.code_status_class = 'input-error';
              } else {
                this.code_status_class = 'input-error';
                this.error_message_label = 'Codice errato, riprovare';
                this.utils.abilityOverflow();
              }
              return this.fake_p_reject(null);
            });
        },
      },
    ];
    options.actionButtons = this.actionButtons;
  }

  sendNewOtpCode() {
    this.error_message_label = null;
    this.code_status_class = 'input-field';

    this.new_sms_sent = true;
    return this.sendMeOtpCode();
  }

  onFocusCode(reset) {
    if (reset) {
      this.code_1 = null;
      this.code_2 = null;
      this.code_3 = null;
      this.code_4 = null;
    }
    this.new_sms_sent = false;
    this.code_status_class = 'input-field';
    this.error_message_label = null;
    return;
  }

  changeIt(e, index) {
    if (e.key === 'Backspace') {
      switch (index) {
        case 3:
          document.getElementById('input-input_code_1').focus();
          break;
        case 4:
          document.getElementById('input-input_code_2').focus();
          break;
        case 5:
          document.getElementById('input-input_code_3').focus();
          break;
      }
    } else {
      switch (index) {
        case 2:
          document.getElementById('input-input_code_2').focus();
          break;
        case 3:
          document.getElementById('input-input_code_3').focus();
          break;
        case 4:
          document.getElementById('input-input_code_4').focus();
          break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/alg-otp-modal/alg-otp-modal.component.ts